<template>
  <div class="pop_delivery pop_bege popup_wrap" style="display:block">
    <div class="popup_in">
      <div class="popup">
        <div class="popup_close stay_close close-animate">
          <a href="javascript:void(0);" @click.prevent="closePop">
            <close />
          </a>
        </div>
        <div class="pop_frame">
          <div class="pp_deliver1" v-if="enter">
            <h2 class="title25">לאן לשלוח?</h2>
            <div class="deliver_img1">
              <img :src="assets + '/layout/deliver1.png'" />
            </div>
            <div class="text">
              שירות המשלוחים שלנו מתרחב,
              <br />אבל רק נוודא שאנחנו מגיעים עד
              אליך
            </div>
            <form method="post" @submit.prevent="formSubmit">
              <vue-simple-suggest
                mode="select"
                class="cities_suggest"
                :list="getCities"
                :prevent-submit="false"
                value-attribute="city_name"
                display-attribute="city_name"
                :filter-by-query="true"
                
                @hover="onHover"
              >
                <div class="form_input">
                  <input type="text" v-model="city" placeholder="שם הישוב" />
                  <div class="error_tx " v-if="error">
                      שכחת לכתוב לנו את שם היישוב ...
                  </div>
                </div>
                <template
                  slot="suggestion-item"
                  slot-scope="{
                    suggestion
                  }"
                  class="custom"
                >
                  <div class="clearfix">
                    <span class="right autoc_tx">
                      <span class="city_title" v-html="suggestion.city_name"></span>
                    </span>
                  </div>
                </template>
              </vue-simple-suggest>
            <!-- <div class="form_select">
            <select2
        
              v-validate="'required'"
              v-model="city"
              key="billing_city"
              :placeholder="'חפש עיר...'"
            >
              <option></option>
              <option
                :value="city.name"
                v-for="city in cities_list">{{city.name}}</option>
            </select2>
            <div
              class="error_tx"
              v-if="error"
            >שכחת לכתוב לנו את שם היישוב ...</div>
          </div> -->
              <div class="submit_bt ease">
                <input type="submit" value="בדיקה" />
              </div>
            </form>
            <a
              href="javascript:void(0);"
              style="margin-top: 10px; display:block;"
              class="submit_bt"
              @click="noCity"
            >עזבו, אפשר להמשיך >></a>
          </div>

          <div class="pp_deliver2" v-if="!enter && ok">
            <div class="deliver_img2">
              <img :src="assets + '/layout/deliver2.png'" />
            </div>
            <h2 class="title25">
              איזה כיף!
              <br />
              אנחנו מגיעים ל{{ city }}
            </h2>
            <div class="bt_green ease">
              <a href="javascript:void(0);" @click.prevent="closePop">אפשר להתחיל להזמין</a>
            </div>
            <div class="green_link">
              <a href="javascript:void(0);" @click.prevent="checkAgain">יישוב אחר למשלוח?</a>
            </div>
          </div>

          <div class="pp_deliver3" v-show="!enter && to_far">
            <div class="deliver_img3">
              <img :src="assets + '/layout/deliver3.png'" />
            </div>
            <h2 class="title25">
              בלב אנחנו קרובים,
              <br />אבל עם האוטו זה עדיין רחוק לנו!
            </h2>
            <div class="form-wrap form_before" style=" margin:10px 0;">
              <div class="text" style="margin-bottom: 12px;">
                מצטערים, אבל אנחנו עדיין לא מגיעים
                <span>ל</span>
                <strong>{{city}}</strong>.
                <br />זה יכול להשתנות, ונשמח לעדכן אותך כשזה יקרה.
              </div>
              <div v-html="this.$wpData.delivery_form"></div>
            </div>
            <div class="form_thank" style="display:none">
              <div class="ok-thank">
                <OK />
              </div>
              <b>היי, קיבלנו, תודה!</b>
              <br />ברגע שנגיע לאזור שלך נהיה בקשר :-)
            </div>
            <div class="green_link">
              <a href="javascript:void(0);" @click.prevent="checkAgain">יישוב אחר למשלוח?</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSimpleSuggest from "vue-simple-suggest/dist/cjs";
import "vue-simple-suggest/dist/styles.css";
import close from "../../assets/img/close.svg";
import OK from "../../assets/img/ok.svg";
import select2 from "../../components/Select2";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      enter: true,
      ok: false,
      to_far: false,
      city: "",
      save_city: '',
      //cities_list : JSON.parse(wpData.cities_list),
      assets: wpData.assets_url,
      error: false
    };
  },
  watch: {
    to_far(value) {
      if (value) {
        // wpcf7.initForm(jQuery(".wpcf7-form"));
        setTimeout(() => {
          document.addEventListener("wpcf7mailsent", function(event) {
            if (event.detail.apiResponse.status == "mail_sent") {
              var $form = document.querySelector(".form_before");
              var $thank = document.querySelector(".form_thank");
              $form.setAttribute("style", "display: none");
              $thank.setAttribute("style", "display:block");
            }
          });
        }, 3000);
      }
    }
  },
  mounted() {
    setTimeout(() => {
      wpcf7.initForm(jQuery(".wpcf7-form"));
      $(".wpcf7 .submit_bt").on("click", function(e) {
        $(".wpcf7 .submit_bt").addClass("proccessing");
      });
      $(".wpcf7").on("wpcf7invalid", function(e) {
        $(".wpcf7 .submit_bt").removeClass("proccessing");
      });
      $(".wpcf7").on("wpcf7submit", function(e) {
        $(".wpcf7 .submit_bt").removeClass("proccessing");
      });
      document.addEventListener("wpcf7mailsent", function(event) {
        if (event.detail.apiResponse.status == "mail_sent") {
          var $form = document.querySelector(".form_before");
          var $thank = document.querySelector(".form_thank");
          var submit = document.querySelector(".submit_bt");
          submit.classList.remove("proccessing");
          $form.setAttribute("style", "display: none");
          $thank.setAttribute("style", "display:block");
        }
      });
    }, 3000);
  },
  computed: {
    getCities() {
      return this.$store.state.cities;
    }
  },
  methods: {
    ...mapActions(["checkCity", "setCity"]),
    closePop: function() {
      if (!this.ok) {
         this.setCity(" ");
      this.ok = true;
      }
      this.$modal.hide("delivery");
    },
    // onHover(value) {
    //   this.city = value.city_name;
    // },
    formSubmit: function() {
      this.error = false;
     if (this.city.length > 3) {
      //  this.city = this.city.replace(/(\r\n|\n|\r)/gm, "");
      //   if (this.city == 'תל אביב - יפו') {
      //     this.city = 'תל אביב';
      //   }
        // this.save_city = this.city;
       this.checkCity(this.city)
        .then(res => {
          this.enter = false;
          this.ok = true;
          // console.log(res);
          // console.log(this.save_city);
          
          // this.setCity(this.save_city);
          this.setCity(this.city);
        })
        .catch(e => {
          this.to_far = true;
          var input_city = document.querySelector("input[name=your-city]");
          let $this = this;

          input_city.value = $this.city;
          this.enter = false;
        });
     }
     else{
       this.error = true;
     }
    },
    noCity() {
      this.setCity(" ");
      this.ok = true;
      this.closePop();
    },
    checkAgain: function() {
      this.enter = true;
      this.city = "";
      this.ok = this.to_far = false;
      var $form = document.querySelector(".form_before");
      var $thank = document.querySelector(".form_thank");
      $thank.setAttribute("style", "display: none");
      $form.setAttribute("style", "display:block");
    }
  },
  components: { close, VueSimpleSuggest, OK,select2 }
};
</script>
<style>
.pop_delivery .vue-simple-suggest.designed .suggestions {
  top: calc(100% + -1px)!important;
  max-width: 290px!important;
  transform: translateX(-42%)!important;
  overflow-x: hidden;
  overflow-y: visible;
}
.cities_suggest .autoc_tx{
      width: 100%;
    margin-right: 0;
    padding-top: 5px;
    text-align: center;

}
@media( max-width: 800px){
  .vue-simple-suggest.designed, .vue-simple-suggest.designed * {

    max-width: 290px;
    margin: 0 auto;
}
  .pop_delivery .vue-simple-suggest.designed .suggestions {
  transform: translateX(0%)!important;

}
}
</style>
